import { render, staticRenderFns } from "./CoopMakerDash.vue?vue&type=template&id=31b1c40b"
import script from "./CoopMakerDash.vue?vue&type=script&lang=js"
export * from "./CoopMakerDash.vue?vue&type=script&lang=js"
import style0 from "./CoopMakerDash.vue?vue&type=style&index=0&id=31b1c40b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports